export const TypesSolServ = {
    RESETSOLSERV: "RESETSOLSERV",
    PREPARASOLSERV: "PREPARASOLSERV",
    ATUALIZAR_LOCALIDADES: "ATUALIZAR_LOCALIDADES",
    SET_LOCAL_OPERACAO: "SET_LOCAL_OPERACAO",
    SET_TIPO_OPERACAO: "SET_TIPO_OPERACAO",
    SET_CONTAINERID: "SET_CONTAINERID",
    SET_LOTE: "solServ/SET_LOTE",
    SET_CONTAINER_NUMERO: "solServ/SET_CONTAINER_NUMERO",
    SET_LOCALIDADE_CONTAINER: "SET_LOCALIDADE_CONTAINER",
    SET_ITENS_ESTUFAGEM: "SET_ITENS_ESTUFAGEM",
    SET_DOCUMENTOITEMID: "SET_DOCUMENTOITEMID",
    SET_VOLUME_PESQUISADO: "SET_VOLUME_PESQUISADO",
    SET_ETIQUETA_BIPADA: "SET_ETIQUETA_BIPADA",
    SET_DETALHES_VOLUME_PESQUISADO: "SET_DETALHES_VOLUME_PESQUISADO",
    SET_DIVERGENCIAS: "SET_DIVERGENCIAS",
    SET_PODE_FINALIZAR_OPERACAO: "solserv/SET_PODE_FINALIZAR_OPERACAO",
    SET_CONDICAO_CONTAINER: "SET_CONDICAO_CONTAINER",
    SET_PEACAO: "solServ/SET_PEACAO",
    SET_EMBALAGENS: "solServ/SET_EMBALAGENS",
    SET_ACRESCIMO: "solServ/SET_ACRESCIMO",
    REMOVE_MATERIAL_PEACAO: "REMOVE_MATERIAL_PEACAO",
    RESET_PEACAOARRAY: "solServ/RESET_PEACAOARRAY",
    SET_TIPO_LACRE: "SET_TIPO_LACRE",
    SET_NUMERO_LACRE: "SET_NUMERO_LACRE",
    SET_TIPOS_DE_LACRE: "SET_TIPOS_DE_LACRE",
    SET_LACRES: "SET_LACRES",
    RESET_LACRE: "RESET_LACRE",
    SET_TYPES_CHECKED: "SET_TYPES_CHECKED",
    RESET_VOLUME_PESQUISADO: "RESET_VOLUME_PESQUISADO",
    SET_EMPILHADEIRA_SELECIONADA: "SET_EMPILHADEIRA_SELECIONADA",
    RESET_TROCA_CONTAINER: "RESET_TROCA_CONTAINER",
    RESET_LOCAL_OPERACAO: "RESET_LOCAL_OPERACAO",
    RESETSOLSERV_LACRES: "RESETSOLSERV_LACRES",
    RESETSOLSERV_PEACAO: "RESETSOLSERV_PEACAO",
    RESET_AVARIAS: "solServ/RESET_AVARIAS",
    RESET_DESOVA: "solServ/RESET_DESOVA",
    RESET_ACRESCIMO: "solServ/RESET_ACRESCIMO",
    SET_QUANTIDADE_AJUDANTES: "solServ/SET_QUANTIDADE_AJUDANTES",
    SET_DESOVA_PROPERTY: "solServ/SET_DESOVA_PROPERTY"
}

export const INITIAL = {
    Sucesso: false,
    Mensagem: null,
    TipoServico: 0,
    DescricaoServico: null,
    SolServID: 0,
    SolicitanteReferencia: null,
    Icone: null,
    EmpilhadeiraSugerir: 0,
    IconeNome: null,
    LocalOperacaoId: 0,
    ContainerId: 0,
    ContainerNumero: '',
    Lote: 0,
    TipoOperacao: 0,
    DocumentoItemId: 0,
    VolumePesquisado: 0,
    EtiquetaBipada: '',
    LocalidadeContainer: 0,
    Nodes: [],
    ItensEstufagem: [],
    Empilhadeiras: [],
    MotivosInterrupcao: [],
    LocalOperacao: [],
    DetalhesVolume: [],
    EmpilhadeiraSelecionada: null,
    Divergencias: '',
    PodeFinalizarOperacao: true,
    CondicaoContainer: 0,
    Lacre: {
        numero: '',
        tipoLacre: -1
    },
    TiposDeLacre: [],
    Lacres: [],
    TypesChecked: [],
    Peacao: {
        materiais: [],
        quantidade: undefined,
        material: undefined,
        materiaisUtilizados: [],
        materialDescricao: ''
    },
    QuantidadeAjudantes: 0,
    Desova: {
        tipo: 0,
        descricaoEmbalagemRegular: '',
        descricaoEmbalagem: '',
        quantidadeRegular: undefined,
        onu: '',
        volume: '',
        etiqueta: '',
        labelLocal: '',
        localidades: [],
        localidade: undefined,
        descricaoLocalidade: '',
        localidadePaiId: undefined,
        localidadeObjeto: {},
        empilhadeiras: [],
        embalagens: [],
        Avarias: [],
        LocaisAvaria: [],
        TiposAvaria: [],
        ComplementosAvaria: [],
        ProvidenciasAvaria: [],
        avariaLocalChecked: [],
        avariaTipoChecked: [],
        avariaComplementoChecked: [],
        avariaProvidenciaChecked: [],
        avariaPeso: undefined,
        avariaRemoverChecked: [],
        detalhesVolume: '',
        loteAlteracao: undefined,

        condicaoContainer: 1,
        tipoOperacao: 0,
        divergencias: '',
        observacao: '',
        lacreMarimex: '',
        listaAjudantes: [],
        ajudantes: [],
    },
    Acrescimo: {
        qtde: null,
        descricao: '',
        embalagem: -1,
        marca: '',
        onu: '',
        peso: null
    },
    embalagens: []
}

export default function solServReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesSolServ.RESETSOLSERV:
            return INITIAL;
        default:
            return state;
        case TypesSolServ.PREPARASOLSERV:
            return {
                ...state,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                TipoServico: action.payload.TipoServico,
                DescricaoServico: action.payload.DescricaoServico,
                SolServID: action.payload.SolServID,
                SolicitanteReferencia: action.payload.SolicitanteReferencia,
                Icone: action.payload.Icone,
                IconeNome: action.payload.IconeNome,
                LocalOperacaoId: 0,
                TipoOperacao: 0,
                ContainerId: 0,
                DocumentoItemId: 0,
                VolumePesquisado: 0,
                EmpilhadeiraSugerir: action.payload.EmpilhadeiraSugerir,
                Nodes: action.payload.Nodes,
                Empilhadeiras: action.payload.Empilhadeiras,
                MotivosInterrupcao: action.payload.MotivosInterrupcao,
                LocalOperacao: action.payload.LocalOperacao,
                DetalhesVolume: action.payload.DetalhesVolume,
                EmpilhadeiraSelecionada: null,
                Divergencias: ''
            }
        case TypesSolServ.ATUALIZAR_LOCALIDADES:
            return {
                ...state,
                LocalOperacao: action.payload.localidades
            }
        case TypesSolServ.SET_LOCAL_OPERACAO:
            return {
                ...state,
                LocalOperacaoId: action.payload.LocalOperacaoId
            }
        case TypesSolServ.SET_TIPO_OPERACAO:
            return {
                ...state,
                TipoOperacao: action.payload.TipoOperacao
            }
        case TypesSolServ.SET_CONTAINERID:
            return {
                ...state,
                ContainerId: action.payload.ContainerId
            }
        case TypesSolServ.SET_CONTAINER_NUMERO:
            return {
                ...state,
                ContainerNumero: action.payload.ContainerNumero
            }
        case TypesSolServ.SET_LOTE:
            return {
                ...state,
                Lote: action.payload.Lote
            }
        case TypesSolServ.SET_LOCALIDADE_CONTAINER:
            return {
                ...state,
                LocalidadeContainer: action.payload.LocalidadeContainer
            }
        case TypesSolServ.SET_ITENS_ESTUFAGEM:
            return {
                ...state,
                ItensEstufagem: action.payload.ItensEstufagem
            }
        case TypesSolServ.SET_DOCUMENTOITEMID:
            return {
                ...state,
                DocumentoItemId: action.payload.DocumentoItemId
            }
        case TypesSolServ.SET_VOLUME_PESQUISADO:
            return {
                ...state,
                VolumePesquisado: action.payload.VolumePesquisado
            }
        case TypesSolServ.SET_ETIQUETA_BIPADA:
            return {
                ...state,
                EtiquetaBipada: action.payload.EtiquetaBipada
            }
        case TypesSolServ.SET_DETALHES_VOLUME_PESQUISADO:
            return {
                ...state,
                DetalhesVolume: action.payload.DetalhesVolume
            }
        case TypesSolServ.SET_DIVERGENCIAS:
            return {
                ...state,
                Divergencias: action.payload.Divergencias
            }
        case TypesSolServ.SET_PODE_FINALIZAR_OPERACAO:
            return {
                ...state,
                PodeFinalizarOperacao: action.payload.PodeFinalizarOperacao
            }
        case TypesSolServ.SET_CONDICAO_CONTAINER:
            return {
                ...state,
                CondicaoContainer: action.payload.CondicaoContainer
            }
        case TypesSolServ.SET_PEACAO:
            let peacaoNew = {};

            Object.assign(peacaoNew, state.Peacao);

            peacaoNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                Peacao: peacaoNew
            }
        case TypesSolServ.SET_EMBALAGENS:
            return {
                ...state,
                embalagens: action.payload
            }
        case TypesSolServ.SET_ACRESCIMO:
            let acrescimoNew = {};

            Object.assign(acrescimoNew, state.Acrescimo);

            acrescimoNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                Acrescimo: acrescimoNew
            }
        case TypesSolServ.REMOVE_MATERIAL_PEACAO:
            return ({
                ...state,
                Peacao: {
                    ...state.Peacao,
                    materiaisUtilizados: [...state.Peacao.materiaisUtilizados.filter(function (a) { return !action.payload.includes(a.materialId) })]
                }
            })
        case TypesSolServ.RESET_PEACAOARRAY:
            let resetPeacaoArray = {};

            Object.assign(resetPeacaoArray, state.Peacao);

            return {
                ...state,
                Peacao: resetPeacaoArray
            }
        case TypesSolServ.SET_TIPO_LACRE:
            let lacreT = {};

            Object.assign(lacreT, state.Lacre);

            lacreT.tipoLacre = action.payload.TipoLacre

            return {
                ...state,
                Lacre: lacreT
            }
        case TypesSolServ.SET_NUMERO_LACRE:
            let lacreN = {};

            Object.assign(lacreN, state.Lacre);

            lacreN.numero = action.payload.Numero

            return {
                ...state,
                Lacre: lacreN
            }
        case TypesSolServ.SET_TIPOS_DE_LACRE:
            return {
                ...state,
                TiposDeLacre: action.payload.TiposDeLacre
            }
        case TypesSolServ.SET_LACRES:
            return {
                ...state,
                Lacres: action.payload.Lacres
            }
        case TypesSolServ.RESET_LACRE:
            return {
                ...state,
                Lacre: INITIAL.Lacre
            }
        case TypesSolServ.SET_TYPES_CHECKED:
            return {
                ...state,
                TypesChecked: action.payload.TypesChecked
            }
        case TypesSolServ.RESET_VOLUME_PESQUISADO:
            return {
                ...state,
                VolumePesquisado: 0,
                DetalhesVolume: [],
                LocalOperacao: [],
                LocalOperacaoId: 0
            }
        case TypesSolServ.SET_EMPILHADEIRA_SELECIONADA:
            return {
                ...state,
                EmpilhadeiraSelecionada: action.payload.EmpilhadeiraSelecionada
            }
        case TypesSolServ.RESET_TROCA_CONTAINER:
            return {
                ...state,
                LocalOperacaoId: 0,
                TipoOperacao: 0,
                DocumentoItemId: 0,
                VolumePesquisado: 0,
                DetalhesVolume: [],
                EmpilhadeiraSelecionada: null
            }
        case TypesSolServ.RESET_LOCAL_OPERACAO:
            return {
                ...state,
                LocalOperacao: []
            }
        case TypesSolServ.RESETSOLSERV_LACRES:
            return {
                ...state,
                Lacre: {
                    numero: '',
                    tipoLacre: -1
                },
                Lacres: []
            }
        case TypesSolServ.RESETSOLSERV_PEACAO:
            return {
                ...state,
                Peacao: {
                    materiais: [],
                    quantidade: undefined,
                    material: undefined,
                    materiaisUtilizados: [],
                    materialDescricao: ''
                }
            }
        case TypesSolServ.SET_QUANTIDADE_AJUDANTES:
            return {
                ...state,
                QuantidadeAjudantes: action.payload.QuantidadeAjudantes
            }
        case TypesSolServ.SET_DESOVA_PROPERTY:

            let desovaNew = {};

            Object.assign(desovaNew, state.Desova);

            desovaNew[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                Desova: desovaNew
            }
        case TypesSolServ.RESET_AVARIAS:
            return {
                ...state,
                Desova: {
                    ...state.Desova,
                    TiposAvaria: INITIAL.Desova.TiposAvaria,
                    LocaisAvaria: INITIAL.Desova.LocaisAvaria,
                    ComplementosAvaria: INITIAL.Desova.ComplementosAvaria,
                    ProvidenciasAvaria: INITIAL.Desova.ProvidenciasAvaria,
                    Avarias: INITIAL.Desova.Avarias,
                    avariaLocalChecked: INITIAL.Desova.avariaLocalChecked,
                    avariaTipoChecked: INITIAL.Desova.avariaTipoChecked,
                    avariaComplementoChecked: INITIAL.Desova.avariaComplementoChecked,
                    avariaProvidenciaChecked: INITIAL.Desova.avariaProvidenciaChecked,
                    avariaRemoverChecked: INITIAL.Desova.avariaRemoverChecked,
                    avariaPeso: INITIAL.Desova.avariaPeso
                }
            }
        case TypesSolServ.RESET_DESOVA:
            return {
                ...state,
                Desova: INITIAL.Desova
            }
        case TypesSolServ.RESET_ACRESCIMO:
            return {
                ...state,
                Acrescimo: INITIAL.Acrescimo
            }
    }
}

export const SolServActions = {
    resetStateSolServ,
    resetStateSolServLacres,
    resetStateSolServPeacao,
    preparaSolServ,
    setLocalidades,
    setLocalOperacao,
    setTipoOperacao,
    setContainerId,
    setContainerNumero,
    setLote,
    setLocalidadeContainer,
    setItensEstufagem,
    setDocumentoItemId,
    setVolumePesquisado,
    setEtiquetaBipada,
    setDetalhesVolumePesquisado,
    setDivergencias,
    setPodeFinalizarOperacao,
    setCondicaoContainer,
    setPeacao,
    setEmbalagens,
    setAcrescimo,
    deletarMaterialPeacao,
    resetPeacao,
    setTipoLacre,
    setNumeroLacre,
    setTiposDeLacre,
    setLacres,
    resetLacre,
    setTypesChecked,
    resetVolumePesquisado,
    setEmpilhadeiraSelecionada,
    resetTrocaContainer,
    resetLocalOperacao,
    resetDesova,
    setQuantidadeAjudantes,
    setDesovaProperty,
    resetAcrescimo,
    resetAvarias
}

function resetStateSolServ() {
    return { type: "RESETSOLSERV" }
}

function resetLocalOperacao() {
    return { type: "RESET_LOCAL_OPERACAO" }
}

function resetStateSolServLacres() {
    return { type: "RESETSOLSERV_LACRES" }
}

function resetStateSolServPeacao() {
    return { type: "RESETSOLSERV_PEACAO" }
}

function preparaSolServ(dadosPreparaSolServ) {
    let dados = dadosPreparaSolServ;
    return {
        type: TypesSolServ.PREPARASOLSERV,
        payload: dadosPreparaSolServ
    }
}

function setLocalidades(localidades) {
    return {
        type: TypesSolServ.ATUALIZAR_LOCALIDADES,
        payload: { localidades: localidades }
    }
}

function setLocalOperacao(id) {
    return {
        type: TypesSolServ.SET_LOCAL_OPERACAO,
        payload: { LocalOperacaoId: id }
    }
}

function setTipoOperacao(id) {
    return {
        type: TypesSolServ.SET_TIPO_OPERACAO,
        payload: { TipoOperacao: id }
    }
}

function setContainerId(id) {
    return {
        type: TypesSolServ.SET_CONTAINERID,
        payload: { ContainerId: id }
    }
}

function setContainerNumero(containerNumero) {
    return {
        type: TypesSolServ.SET_CONTAINER_NUMERO,
        payload: { ContainerNumero: containerNumero }
    }
}

function setLote(lote) {
    return {
        type: TypesSolServ.SET_LOTE,
        payload: { Lote: lote }
    }
}

function setLocalidadeContainer(id) {
    return {
        type: TypesSolServ.SET_LOCALIDADE_CONTAINER,
        payload: { LocalidadeContainer: id }
    }
}

function setItensEstufagem(itensEstufagem) {
    return {
        type: TypesSolServ.SET_ITENS_ESTUFAGEM,
        payload: { itensEstufagem: itensEstufagem }
    }
}

function setDocumentoItemId(id) {
    return {
        type: TypesSolServ.SET_DOCUMENTOITEMID,
        payload: { DocumentoItemId: id }
    }
}

function setVolumePesquisado(volume) {
    return {
        type: TypesSolServ.SET_VOLUME_PESQUISADO,
        payload: { VolumePesquisado: volume }
    }
}

function setEtiquetaBipada(etiqueta) {
    return {
        type: TypesSolServ.SET_ETIQUETA_BIPADA,
        payload: { EtiquetaBipada: etiqueta }
    }
}

function setDetalhesVolumePesquisado(dadosVolume) {
    return {
        type: TypesSolServ.SET_DETALHES_VOLUME_PESQUISADO,
        payload: { DetalhesVolume: dadosVolume }
    }
}

function setDivergencias(divergencias) {
    return {
        type: TypesSolServ.SET_DIVERGENCIAS,
        payload: { Divergencias: divergencias }
    }
}

function setPodeFinalizarOperacao(podeFinalizarOperacao) {
    return {
        type: TypesSolServ.SET_PODE_FINALIZAR_OPERACAO,
        payload: { PodeFinalizarOperacao: podeFinalizarOperacao }
    }
}

function setCondicaoContainer(condicao) {
    return {
        type: TypesSolServ.SET_CONDICAO_CONTAINER,
        payload: { CondicaoContainer: condicao }
    }
}

function setPeacao(valor, campo) {
    return {
        type: TypesSolServ.SET_PEACAO,
        payload: { valor: valor, campo: campo }
    }
}

function setEmbalagens(embalagens) {
    return {
        type: TypesSolServ.SET_EMBALAGENS,
        payload: embalagens
    }
}

function setAcrescimo(valor, campo) {
    return {
        type: TypesSolServ.SET_ACRESCIMO,
        payload: { valor: valor, campo: campo }
    }
}

function deletarMaterialPeacao(materiais) {

    let materialDescricaoRemover = [];

    materiais.forEach(element => {
        materialDescricaoRemover.push(element[0]);
    });

    return {
        type: TypesSolServ.REMOVE_MATERIAL_PEACAO,
        payload: materialDescricaoRemover
    }
}

function resetPeacao(array) {
    return {
        type: TypesSolServ.RESET_PEACAOARRAY,
        payload: { array: array }
    }
}

function setTipoLacre(tipoLacre) {
    return {
        type: TypesSolServ.SET_TIPO_LACRE,
        payload: { TipoLacre: tipoLacre }
    }
}

function setNumeroLacre(numero) {
    return {
        type: TypesSolServ.SET_NUMERO_LACRE,
        payload: { Numero: numero }
    }
}

function setTiposDeLacre(tiposDeLacre) {
    return {
        type: TypesSolServ.SET_TIPOS_DE_LACRE,
        payload: { TiposDeLacre: tiposDeLacre }
    }
}

function setLacres(lacres) {
    return {
        type: TypesSolServ.SET_LACRES,
        payload: { Lacres: lacres }
    }
}

function resetLacre() {
    return {
        type: TypesSolServ.RESET_LACRE
    }
}

function setTypesChecked(typesChecked) {
    return {
        type: TypesSolServ.SET_TYPES_CHECKED,
        payload: { TypesChecked: typesChecked }
    }
}

function resetVolumePesquisado() {
    return { type: "RESET_VOLUME_PESQUISADO" }
}

function setEmpilhadeiraSelecionada(empilhadeira) {
    return {
        type: TypesSolServ.SET_EMPILHADEIRA_SELECIONADA,
        payload: { EmpilhadeiraSelecionada: empilhadeira }
    }
}

function resetTrocaContainer() {
    return { type: "RESET_TROCA_CONTAINER" }
}

function setQuantidadeAjudantes(quantidadeAjudantes) {
    return {
        type: TypesSolServ.SET_QUANTIDADE_AJUDANTES,
        payload: { QuantidadeAjudantes: quantidadeAjudantes }
    }
}

function setDesovaProperty(valor, campo) {
    return {
        type: TypesSolServ.SET_DESOVA_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function resetAcrescimo() {
    return {
        type: TypesSolServ.RESET_ACRESCIMO
    }
}

function resetAvarias() {
    return {
        type: TypesSolServ.RESET_AVARIAS
    }
}

function resetDesova() {
    return {
        type: TypesSolServ.RESET_DESOVA
    }
}